const footerNavItems = [
  {
    title: '快速导航',
    links: [
      { label: '热门推荐', href: '#carousel' },
      { label: '漫画分类', href: '#index' },
      { label: '话题热榜', href: '#topics' },
      { label: '精选推荐', href: '#cards' },
      { label: '人气排行', href: '#ranking' },
      { label: '最新动态', href: '#updates' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '平台优势', href: '#features' },
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '恋爱漫画', href: '#index' },
      { label: '奇幻漫画', href: '#index' },
      { label: '动作漫画', href: '#index' },
      { label: '悬疑漫画', href: '#index' },
      { label: '校园漫画', href: '#index' },
      { label: '穿越漫画', href: '#index' },
    ],
  },
];

export default function Footer() {
  const handleFooterNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  韩国漫画网
                </span>
              </div>
              <p className="text-sm text-background-50/60 leading-relaxed mb-4">
                韩国漫画网站大全平台，提供海量免费韩漫在线看，支持下拉式阅读，实时追更热门漫画，日更不断更。
              </p>
              <div className="flex items-center gap-3">
                <a href="#contact" onClick={(e) => handleFooterNav(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-background-50/80"></i>
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); }} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-background-50/80"></i>
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); }} className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-background-50/80"></i>
                </a>
              </div>
            </div>

            {footerNavItems.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => handleFooterNav(e, link.href)}
                        className="text-sm text-background-50/55 hover:text-background-50 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 md:mt-12 pt-6 border-t border-background-50/10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex flex-wrap items-center gap-4 text-xs text-background-50/45">
                <span>韩国漫画网</span>
                <span className="hidden sm:inline opacity-40">|</span>
                <span>韩国漫画网站大全 · 免费韩漫在线看</span>
              </div>
              <div className="flex items-center gap-4 text-xs text-background-50/45">
                <a href="#hero" onClick={(e) => handleFooterNav(e, '#hero')} className="hover:text-background-50/70 transition-colors cursor-pointer">首页</a>
                <a href="#faq" onClick={(e) => handleFooterNav(e, '#faq')} className="hover:text-background-50/70 transition-colors cursor-pointer">FAQ</a>
                <a href="#contact" onClick={(e) => handleFooterNav(e, '#contact')} className="hover:text-background-50/70 transition-colors cursor-pointer">联系我们</a>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-50/10">
            <h4 className="text-xs font-semibold text-background-50/40 mb-3 text-center">合作伙伴</h4>
            <div className="flex flex-wrap justify-center gap-6 items-center">
              <span className="text-xs text-background-50/25">虚位以待</span>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-[10px] text-background-50/30">
              &copy; {new Date().getFullYear()} 韩国漫画网 krmh.example.com. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}